import React from "react";

/**
 * Represents a simple file to be shown in a file list.
 * @author Johan Svensson
 */
export default class UploadedFile {
  /**
   * Creates an instance with metadata from a file.
   * This is meant to represent the file before it has been uploaded,
   * hence the instance does not have an `id` or `uri` assigned.
   */
  static fromFile(file: File, id: string | null = null) {
    return new UploadedFile({
      id,
      name: file.name,
      names: [file.name],
      uri: null,
      mimetype: file.type,
      file
    });
  }

  readonly id: any;
  readonly name: string;

  /**
   * Current and previous names.
   */
  readonly names?: string[];
  readonly uri: string;
  readonly mimetype?: string;
  readonly file?: File;
  readonly width?: number;
  readonly height?: number;

  constructor(deriveFrom?: Partial<UploadedFile>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    this.names = this.names ?? [this.name];
  }
}

export class ListableFile extends UploadedFile {
  description?: React.ReactChild;
  disabled?: boolean;
  /**
   * @default true
   */
  deletable?: boolean;
}